// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-block[data-v-8dc62e0a]{border-radius:25px;margin-top:1rem;margin-bottom:1rem}.block-item-link[data-v-8dc62e0a]:hover{text-decoration:none}", ""]);
// Exports
module.exports = exports;
